import * as React from 'react'
import { IActiveTripResponseV2 } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import ImageView from '../../ui/ImageView'
import { mapViewStrategyStages } from '../../MapView'
import ETADisplay from './ETA'
import TripActivityLog from '../../../containers/trips/TripActivityLog'
import { ITripGroupRides } from 'src/types/trip-group-rides'
import TripPaymentDisplay from './TripRiderDetails'

export interface ITripWaitingForPickupProps {
  currentTrip: IActiveTripResponseV2
  getTripById: (tripId: string) => void
  setCurrentTripStage: (stage: string) => void
}

class TripWaitingForPickup extends React.Component<ITripWaitingForPickupProps> {
  private tripTimerId: any

  public componentDidMount() {
    this.tripTimerId = setInterval(this.refreshTrip, 60000)
    this.props.setCurrentTripStage(mapViewStrategyStages.liveTrip)
  }

  public componentWillUnmount() {
    clearInterval(this.tripTimerId)
  }

  public render() {
    const trip = this.props.currentTrip

    if (!trip) {
      return null
    }

    const etaOrigin = trip.operatorLocation
      ? {
          lat: trip.operatorLocation.coordinates[1],
          lng: trip.operatorLocation.coordinates[0]
        }
      : null

    const estimatedLoadingTime = trip.product.estimatedLoadingTime

    const etaDestination = trip.operatorLocation
      ? {
          lat: trip.pickupLocation.latitude,
          lng: trip.pickupLocation.longitude
        }
      : null

    const operatorName = trip.operator ? `${trip.operator.firstName} ${trip.operator.lastName}` : 'No operator assigned'
    const operatorPhone = trip.operator ? trip.operator.phone : ''

    const vehicleInfo = trip.vehicle ? `${trip.vehicle.make} ${trip.vehicle.model}` : 'No vehicle assigned'

    const licensePlate = trip.vehicle ? trip.vehicle.licensePlate : 'No Plate'

    const paymentMode =
      trip.tripsGroupRides[0] && trip.tripsGroupRides[0].fareType ? trip.tripsGroupRides[0].fareType : 'Wallet'

    return (
      <div className='px2 py2'>
        <div className='flex '>
          <ImageView entityId={trip.operator ? trip.operator.id : undefined} width='40px' height='40px' />
          <div className='col-10 pl2'>
            <div className='flex'>
              <p className='m0 font-black'>{operatorName}</p>
            </div>
            <div className='h6 font-grey2'>
              {trip.service.name} {trip.product.name}
            </div>
          </div>
        </div>
        <div className='h6 font-grey2 pl1 mt1'>
          <span className='h6 font-black mr1'>Notes:</span>
          {trip.notes}
        </div>
        <TripPaymentDisplay
          tripsGroupRides={trip.tripsGroupRides}
          paymentMode={paymentMode}
          serviceId={trip.service.serviceId}
          tripId={trip.id}
        />
        <div className='col-12'>
          <div className='flex items-center justify-between mt2 h6'>
            <p className='m0 font-black'>{vehicleInfo}</p>
            <div>
              <p className='car-number'>{licensePlate}</p>
            </div>
          </div>
          <div>
            <div className='flex items-center justify-between mt1 h6'>
              <p className='m0 font-black'>{UIMessages.trip.estimatedPickup}</p>
              <p className='m0'>
                <ETADisplay className='font-blue bold' origin={etaOrigin} destination={etaDestination} />
              </p>
            </div>
            {/* <TripActivityLog currentTrip={this.props.currentTrip} /> */}
          </div>
          <div>
            <div className='flex items-center justify-between mt1 h6'>
              <p className='m0 font-black'>{UIMessages.trip.estimatedLoadingTime}</p>
              <p className='m0'>
                <span className='font-blue bold'>
                  {estimatedLoadingTime ? `${estimatedLoadingTime} mins` : 'Unavailable'}
                </span>
              </p>
            </div>
            {/* <TripActivityLog currentTrip={this.props.currentTrip} /> */}
          </div>
        </div>
      </div>
    )
  }

  private refreshTrip = () => {
    this.props.getTripById(this.props.currentTrip.id)
  }
}

export default TripWaitingForPickup



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripWaitingForPickup.tsx